import React from "react"
import EditorSection from "components/Builder/components/EditorSection"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import { Text } from "@chakra-ui/react"
import PaddingInputs from "components/Builder/components/PaddingInputs"
import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import { Control } from "react-hook-form"
import { TEMPORAL_QR_CODES_ARTICLE_LINK } from "utilities/externalLinks"
import Link from "components/elements/Link"

type Props = {
  control: Control
}

const QRCodeFields = ({ control }: Props) => (
  <>
    <SidePanelHeader>QR Code Block</SidePanelHeader>
    <EditorSection>
      <Text mb={4}>
        The QR code shown here is a placeholder. Each guest will receive their own unique
        QR code when the email is sent.
      </Text>
      <Text mb={4}>
        This block also supports Temporal QR Codes and will include a link
        for guests to open their live code. Learn more:{" "}
        <Link href={TEMPORAL_QR_CODES_ARTICLE_LINK} isExternal>
          Temporal QR Codes
        </Link>.
      </Text>
    </EditorSection>
    <EditorSection>
      <PaddingInputs control={control} />
    </EditorSection>
    <EditorSection>
      <ColorSelect label="Block Color" name="blockColor" control={control} colorScheme="light" />
    </EditorSection>
  </>
)

export default QRCodeFields
